import { DictGeoOutputSchema as o, DictOSTypeOutputSchema as t, DictAdUnitTypesOutputSchema as s, DictDeviceSchema as r, DictBrowserSchema as c, DictCategorySchema as i, DictLanguageOutputSchema as m, DictDealTypeOutputSchema as y, DictContentTypeOutputSchema as d, CpaAutoRuleIdSchema as l, DictBlacklistStatusSchema as S, DictBlacklistBanTypeSchema as p, DictBlacklistConditionParamSchema as h, UserIdSchema as a } from "@hprofits/shared";
import { z as e } from "zod";
import { AdTagSchema as u } from "../creative-group/schemas.js";
const n = e.enum(["flat", "full"]).default("flat"), v = e.object({ mode: n }).readonly(), f = e.array(o).readonly(), U = e.object({ mode: n }).readonly(), k = e.array(t).readonly(), w = e.object({ mode: n }).readonly(), I = e.array(s).readonly(), z = e.array(r).readonly(), L = e.array(c).readonly(), Q = e.array(i).readonly(), P = e.array(m).readonly(), x = e.array(y).readonly(), G = e.array(d).readonly(), R = e.object({
  id: l,
  name: e.string()
}).readonly(), M = e.array(R).readonly(), N = e.array(S).readonly(), q = e.array(p).readonly(), E = e.array(h).readonly(), g = e.object({
  id: a,
  email: e.string()
}).readonly(), F = e.array(g).readonly(), D = e.object({
  // No branded site id exists in @hprofits/shared yet, unlike UserIdSchema above.
  id: e.int().positive(),
  name: e.string(),
  domain: e.string(),
  userId: a,
  // `sites.status_id`: 1 pending, 2 active, 3 rejected, 4 paused (no dictionary table exists).
  statusId: e.int().nullable()
}).readonly(), H = e.array(D).readonly(), b = e.object({
  id: a,
  email: e.string()
}).readonly(), J = e.array(b).readonly(), A = e.object({
  id: e.int().positive(),
  name: e.string()
}).readonly(), K = e.array(A).readonly(), T = e.object({
  id: u,
  name: e.string(),
  googleCompliance: e.boolean(),
  forLandings: e.boolean(),
  forCreatives: e.boolean()
}).readonly(), V = e.array(T).readonly(), C = e.object({
  id: e.number().int().positive(),
  width: e.number().int().positive(),
  height: e.number().int().positive()
}).readonly(), W = e.array(C).readonly();
export {
  V as AdTagsResponseSchema,
  g as AdUnitOwnerSchema,
  F as AdUnitOwnersResponseSchema,
  D as AdUnitSiteSchema,
  H as AdUnitSitesResponseSchema,
  w as AdUnitTypeQuerySchema,
  I as AdUnitTypeResponseSchema,
  b as AdvertiserSchema,
  J as AdvertisersResponseSchema,
  W as BannerSizesResponseSchema,
  q as BlacklistBanTypesResponseSchema,
  E as BlacklistConditionParamsResponseSchema,
  N as BlacklistStatusesResponseSchema,
  L as BrowserTypesResponseSchema,
  Q as CategoriesResponseSchema,
  G as ContentTypeResponseSchema,
  v as CountriesQuerySchema,
  f as CountriesResponseSchema,
  R as CpaAutoRuleSchema,
  M as CpaAutoRulesResponseSchema,
  x as DealTypesResponseSchema,
  z as DeviceTypeResponseSchema,
  T as DictAdTagSchema,
  C as DictBannerSizeSchema,
  P as LanguagesResponseSchema,
  n as NestedDictModeSchema,
  U as OsQuerySchema,
  k as OsResponseSchema,
  A as SspSchema,
  K as SspsResponseSchema
};
//# sourceMappingURL=schemas.js.map
